
const validateStoryboard = (formData)=>{
    if (formData.title == null || formData.title.length == 0){
        return "Storyboard title cannot be empty."
    }
}

export default validateStoryboard